import { render, staticRenderFns } from "./GlobalPlayer.vue?vue&type=template&id=4f34a78f&scoped=true&"
import script from "./GlobalPlayer.vue?vue&type=script&lang=js&"
export * from "./GlobalPlayer.vue?vue&type=script&lang=js&"
import style0 from "./GlobalPlayer.vue?vue&type=style&index=0&id=4f34a78f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f34a78f",
  null
  
)

export default component.exports